import { useState } from "react";
import { motion } from "framer-motion";
import { PILLARS } from "@/lib/content";
import { MaskLines, Reveal, EASE } from "@/components/site/Motion";

export function Pillars() {
  const [active, setActive] = useState(0);
  return (
    <section data-testid="pillars-section" className="bg-cream py-24 sm:py-32">
      <div className="wrap">
        <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <div>
            <p className="eyebrow">Three pillars, one routine</p>
            <h2 className="mt-5 text-5xl leading-[0.98] text-forest sm:text-6xl lg:text-7xl">
              <MaskLines lines={["Small things,", <em key="d" className="text-pine">done daily.</em>]} />
            </h2>
          </div>
          <Reveal><p className="max-w-sm text-base leading-relaxed text-charcoal-soft">Every plan we build rests on the same three pillars, in this order. Nourish first. Energy follows. Transformation is what repetition looks like.</p></Reveal>
        </div>

        <div className="mt-14 flex flex-col gap-4 lg:h-[560px] lg:flex-row">
          {PILLARS.map((p, i) => {
            const on = active === i;
            return (
              <motion.button
                key={p.key}
                type="button"
                data-testid={`pillar-${p.key}`}
                onMouseEnter={() => setActive(i)}
                onFocus={() => setActive(i)}
                onClick={() => setActive(i)}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ delay: i * 0.12, duration: 0.9, ease: EASE }}
                className={`group relative h-[420px] overflow-hidden rounded-[30px] text-left transition-[flex-grow] duration-700 ease-[cubic-bezier(.22,1,.36,1)] lg:h-auto ${on ? "lg:flex-[2.6]" : "lg:flex-1"}`}
              >
                <img src={p.image} alt={p.alt} loading="lazy" className={`absolute inset-0 h-full w-full object-cover transition-transform duration-[1400ms] ${on ? "scale-105" : "scale-110"}`} />
                <div className="absolute inset-0 bg-gradient-to-t from-forest-deep/90 via-forest-deep/35 to-forest-deep/10" />
                <div className="relative flex h-full flex-col justify-between p-7 text-cream sm:p-9">
                  <span className="font-display text-xl italic text-gold-soft">{p.num}</span>
                  <div>
                    <h3 className="font-display text-5xl sm:text-6xl">{p.title}</h3>
                    <div className={`grid transition-[grid-template-rows,opacity] duration-700 ${on ? "grid-rows-[1fr] opacity-100" : "grid-rows-[1fr] lg:grid-rows-[0fr] lg:opacity-0"}`}>
                      <p className="mt-4 max-w-sm overflow-hidden text-base leading-relaxed text-cream/90">{p.line}</p>
                    </div>
                  </div>
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
